import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { DealersService } from 'src/app/share/services/dealers/dealers.service';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { MasterModelService } from 'src/app/share/services/master-model/master-model.service';
import { ReturnsService } from 'src/app/share/services/returns/returns.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { MessageService } from 'src/app/share/sharedsubject';

@Component({
    selector: 'app-return-to-dealer',
    templateUrl: './return-to-dealer.component.html',
    styleUrls: ['./return-to-dealer.component.scss'],
    standalone: false
})
export class ReturnToDealerComponent implements OnInit {
  customSearchFn = () => true;
  returnToDealerForm: FormGroup;
  filteredActiveBranches: any[] = [];
  isLoading = false;
  dealerList: any[] = [];
  searchTerm: any = {};
  userDetails: any;
  tyreMakeObj: any = { page: 0, searchTerm: '', list: [] };
  tyreModelObj: any = { page: 0 };
  resMsg: string;
  responseMsg: any;
  selectedTyreSize: any;
  tyreSizeObj: any = { page: 0, searchTerm: '', list: [] };
  endOfDealerList: boolean = false;
  dealerObj: any = { page: 0 };
  tyreModelList: { search: string, list: any[], page: number }[] = [{ search: '', list: [], page: 0 }];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly stockService: StockService,
    private readonly masterModelService: MasterModelService,
    private readonly masterMakeService: MasterMakeService,
    private readonly companyService: CompanyServiceService,
    private readonly returnsService: ReturnsService,
    private readonly dealersService: DealersService,
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly messageService: MessageService
  ) {
    this.returnToDealerForm = this.formBuilder.group({
      dealer: [null, Validators.required],
      company: this.userDetails?.enrollmentType === 'Company' ? [null, Validators.required] : [null],
      stock: this.formBuilder.array([this.returnDetailsGroup()])
    })
  }

  returnDetailsGroup(): FormGroup {
    return this.formBuilder.group({
      tyreSize: [null, Validators.required],
      tyreMake: [null, Validators.required],
      tyreModel: [null],
      quantity: [null, [Validators.required, Validators.min(1)]],
    });
  }

  get stock(): FormArray {
    return this.returnToDealerForm.get('stock') as FormArray;
  }

  addItem(index: number): void {
    this.stock.push(this.returnDetailsGroup());
    this.tyreModelList.push({ search: '', list: [], page: 0 });
  }

  removeItem(index: number): void {
    this.stock.removeAt(index);
    this.tyreModelList.splice(index, 1);
  }

  ngOnInit(): void {
    this.getDealers();
    this.initData();
    this.userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if (this.userDetails?.enrollmentType === 'Company') {
      this.getAllCompanyList();
      this.returnToDealerForm.get('company')?.setValidators([Validators.required]);
      this.returnToDealerForm.get('company')?.setValue(null, { emitEvent: false });
    }
  }

  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      this.filteredActiveBranches = res.data?.filter((c: any) => c.status === 'Active') || [];
    });
  }

  saveReturnData() {
    if (this.isLoading) return;
    this.responseMsg = '';
    this.isLoading = true;
    this.returnsService.saveReturnToDealerDetails({ ...this.returnToDealerForm.value }).subscribe({
      next: (res: any) => {
      setTimeout(() => {
        this.messageService.sendMessage(res.message);
      })
      this.router.navigate(['/order-list'])
      this.isLoading = false;
      this.responseMsg = ''
    },
      error: (error) => {
        this.isLoading = false;
        this.responseMsg = error?.error.error?.message || error?.error?.message[0] || error?.message
      }
    })
  }

  scrollDealer() {
    if (this.endOfDealerList) {
      return;
    } else {
      this.dealerObj.page++
      this.getDealers()
    }
  }

  onDealerInputChange(event: any) {
    this.dealerObj.page = 0;
    let delearSearch = event?.term ? event.term : '';
    this.dealerObj.searchTerm = delearSearch;
    this.getDealers();
  }

  getTyreSize() {
    const apiParams: any = { page: this.tyreSizeObj.page };
    if (this.tyreSizeObj.searchTerm) {
      apiParams.searchTerm = this.tyreSizeObj.searchTerm;
    }
    this.stockService.getTyreDetails(apiParams).subscribe((res: any) => {
      if (this.tyreSizeObj.page === 0) {
        this.tyreSizeObj.list = res.data || [];
      } else {
        this.tyreSizeObj.list = [...this.tyreSizeObj.list, ...(res.data || [])];
      }
    });
  }

  getTyreModel(selectedMake: any, index: number) {
    this.masterModelService.getTyreModelList(selectedMake, this.tyreModelObj).subscribe((res: any) => {
      if (this.tyreModelObj.page == 0) {
        this.tyreModelList[index].list = res.data || []
      }
      else {
        this.tyreModelList[index].list = this.tyreModelList[index].list.concat(res.data || []);
      }
    });
  }

  getTyreMake() {
    this.masterMakeService.getTyreMakeBySize(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm).subscribe((res: any) => {
      if (this.tyreMakeObj.page === 0) {
        this.tyreMakeObj.list = res.data || [];
      } else {
        this.tyreMakeObj.list = [...this.tyreMakeObj.list, ...(res.data || [])];
      }
    });
  }


  getDealers() {
    this.dealersService.getDealerDetails(this.dealerObj).subscribe((res: any) => {
      this.dealerList = this.dealerList.concat(res.data || []);
      if (res.data.length === 0) {
        this.endOfDealerList = true;
      }
    })
  }


  onScrollTyreSize() {
    if (this.tyreSizeObj.list.length % 20 === 0) {
      this.tyreSizeObj.page++;
      this.getTyreSize();
    }
  }

  onTyreSizeInputChange(event: any) {
    this.tyreSizeObj.page = 0;
    let tyreSizeSearch = event?.term ? event.term : '';
    this.tyreSizeObj.searchTerm = tyreSizeSearch;
    this.tyreSizeObj.list = [];
    this.getTyreSize();
  }

  onTyreMakeInputChange(event: any) {
    this.tyreMakeObj.page = 0;
    let tyreMakeSearch = event?.term ? event.term : '';
    this.tyreMakeObj.searchTerm = tyreMakeSearch;
    this.tyreMakeObj.list = [];
    this.getTyreMake();
  }

  selectMake(value: any, index: any) {
    let selectedTyreMake = value || '';
    let selectedTyre: any = this.stock?.controls[index];
    selectedTyre?.controls['tyreModel'].setValue(null);
    this.tyreModelObj.page = 0;
    this.tyreModelObj.tyreMake = selectedTyreMake;
    this.tyreModelObj.name = '';
    this.tyreModelList[index].search = '';
    this.tyreModelList[index].page = 0;
    this.tyreModelList[index].list = [];
    if (value) {
      this.getTyreModel(this.tyreModelObj, index);
    }
  }


  scroll(index: number) {
    if (this.tyreModelList[index].list.length % 20 !== 0) {
      return;
    }
    this.tyreModelObj.name = this.tyreModelList[index].search;
    this.tyreModelList[index].page++;
    this.tyreModelObj.page = this.tyreModelList[index].page;
    let selectedGroup: any = this.stock?.controls[index];
    let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
    this.tyreModelObj.tyreMake = selectedTyreMake;
    this.getTyreModel(this.tyreModelObj, index);

  }

  onTyreModelInputChange(event: any, index: number) {
    this.tyreModelObj.page = 0;
    this.tyreModelList[index].page = 0;
    let tyreModelSearch = event?.term ? event.term : '';
    this.tyreModelList[index].search = tyreModelSearch;
    this.tyreModelObj.name = tyreModelSearch;
    let selectedGroup: any = this.stock?.controls[index];
    let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
    this.tyreModelObj.tyreMake = selectedTyreMake;
    this.getTyreModel(this.tyreModelObj, index);
  }

  initData() {
    this.tyreSizeObj.searchTerm = "";
    this.tyreSizeObj.page = 0;
    this.tyreMakeObj.searchTerm = "";
    this.tyreModelObj.name = "";
    this.getTyreSize();
    this.getTyreMake();
  }

  onSizeClose() {
    if (this.tyreSizeObj.searchTerm) {
      this.tyreSizeObj.page = 0;
      this.tyreSizeObj.searchTerm = '';
      this.getTyreSize();
    }
  }

  onMakeClose() {
    if (this.tyreMakeObj.searchTerm) {
      this.tyreMakeObj.page = 0;
      this.tyreMakeObj.searchTerm = '';
      this.getTyreMake();
    }
  }

  onModelClose(index: number) {
    if (this.tyreModelList[index].search) {
      this.tyreModelList[index].page = 0;
      this.tyreModelList[index].search = '';
      
      this.tyreModelObj.page = 0;
      this.tyreModelObj.name = '';
      
      let selectedGroup: any = this.stock?.controls[index];
      let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = selectedTyreMake;
      
      this.getTyreModel(this.tyreModelObj, index);
    }
  }

  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;


}
